<template>
  <div class="loginBgReg" style="text-align:center;">
    <div class="loginMainReg">
      <div id="login" class="loginReg bgfff">
        <div class="leftReg">
          <img :src="leftImg" />
        </div>
        <div class="rightReg" :style="syStyle">
          <div class="formBoxReg">
            <h3>Welcome to login/register</h3>
            <a href="https://vis.exporegist.com/FIC/#/login?ExhID=2992" style="position: absolute; right: 20px; top: 20px;">中文</a>
            <div style="text-align: left;font-size: 14px;">
              <p>Tips:</p>
              <p>&nbsp;</p>
              <p>For registered audience, you can click on [Login] to access your confirmation letter.</p>
              <p style="margin-top: 10px;">For unregistered audience, please finish your online registration through [Register]</p>
            </div>
            <div
              style="text-align: left;font-size: 14px;"
              class="loginEx"
              v-html="LoginExplain?LoginExplain:''"
            ></div>
            <el-form :model="ruleForm2" ref="ruleForm" class="demo-ruleFormloginReg" @submit.native.prevent>
              <!-- 姓名 -->
              <div class="div-inlineReg">
                <b>Name</b>
                <el-input
                  class="div-inline-rReg"
                  name="userName"
                  v-model="ruleForm2.userName"
                  maxlength="50"
                  placeholder="Please enter your name"
                  @blur="clearSpace('userName')"
                ></el-input>
              </div>
              <!-- 邮箱 -->
              <div class="div-inlineReg">
                <b>Email</b>
                <el-input
                  class="div-inline-r"
                  name="email"
                  v-model="ruleForm2.email"
                  maxlength="50"
                  placeholder="Please enter your correct email address"
                  @blur="clearSpace('email')"
                ></el-input>
              </div>
              <!-- <div class="div-inlineReg">
                <b>滑动验证</b>
                <Verify ref="verify" @success="OK()" @error="ERR()" :type="3" :barSize="barSize"></Verify>
              </div>
              <div class="div-inlineReg">
                <b>短信验证码</b>
                <div class="smsCode flex">
                  <div class="code-input">
                    <el-input
                      name="code"
                      @keyup.native="clearSpace('code')"
                      v-model="ruleForm2.code"
                      placeholder="请输入验证码"
                      maxlength="4"
                    ></el-input>
                  </div>
                  <el-button
                    class="count-down"
                    type="primary"
                    v-if="isDisabled"
                    :disabled="isRefresh"
                  >{{countDownNum}}s</el-button>
                  <el-button class="count-down" type="primary" v-else @click="OK()">获取验证码</el-button>
                </div>
              </div> -->
              <el-button
                class="submit-btn"
                type="primary"
                :style="btnAllStyle"
                :loading="showBtnLoading"
                @click="submit('ruleForm')"
              >Register</el-button>
            </el-form>
          </div>
          <div class="llqTips">
            <Footer/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import regExp from '../utils/regExp.js'
import Footer from '../components/Footer'
import Verify from 'vue2-verify'
import loginImg from '../../static/img/login-img.jpg'
import sybg from '../../static/img/sybg.png'
import utils from '../utils'
export default {
  name: 'Login',
  components: {
    Footer,
    Verify
  },
  data() {
    return {
      loginImg: loginImg,
      userMsg: {
        name: '',
        mobile: ''
      },
      barSize: {
        width: '99%',
        height: '40px'
      },
      switerIndex: 20,
      newSwiterIndex: 0,
      maxSwiterIndex: 300,
      bannerImg: '',
      leftImg: sessionStorage.getItem('leftImg'),
      exhName: '', // 展会名字
      showBtnLoading: false, // load btn
      LoginFont: sessionStorage.getItem('LoginFont'), // 提示信息
      isDisabled: false, // 是否发送验证码
      isInputCode: false, // 是否可以输入验证码
      isRefresh: true,
      countDownNum: 59, // 倒计时
      ImgCodeUrl: '',
      ruleForm2: {
        userName: '',
        iphone: '',
        email: '',
        code: ''
      },
      ExhID: sessionStorage.getItem('ExhID'), // 展会id
      slideVS: false, // 是否已滑动验证
      sybg: sybg,
      syStyle: JSON.parse(sessionStorage.getItem('syStyle')),
      LoginExplain: sessionStorage.getItem('LoginExplain'),
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {}
    }
  },
  mounted() {
    utils.setTitle()
    utils.setThemeColor()
    var obj = sessionStorage.getItem('cacheRegiater')
    if (obj) {
      this.ruleForm2 = JSON.parse(obj)
    }
  },
  methods: {
    regErr () {
      this.$refs.verify.refresh();
      this.slideCode = false; // 将是否滑动状态恢复到初始状态
    },
    OK () {
      var _this = this;
      var obj = _this.ruleForm2;
      if (!regExp.notEmpty.test(obj.userName)) {
        _this.$alert('请输入您的姓名');
        document.getElementsByName('userName')[0].focus();
        this.regErr()
        return ''
      } else if (obj.userName.length < 2) {
        _this.$alert('姓名长度不能小于2位');
        document.getElementsByName('userName')[0].focus();
        this.regErr()
        return ''
      }else if (!regExp.regCheckCnName.test(obj.userName) && !regExp.regCheckEnName.test(obj.userName)) {
        _this.$alert('姓名格式填写错误,请重新输入');
        document.getElementsByName('userName')[0].focus();
        this.regErr()
        return ''
      }else if (!regExp.notEmpty.test(obj.iphone)) {
        _this.$alert('请输入您的手机号');
        document.getElementsByName('iphone')[0].focus();
        this.regErr()
        return ''
      }else if (obj.iphone.length !== 11) {
        _this.$alert('请输入11位的手机号');
        document.getElementsByName('iphone')[0].focus();
        this.regErr()
        return ''
      }else if (!regExp.regCheckCnMobile.test(obj.iphone)) {
        _this.$alert('手机号格式填写错误,请重新输入');
        document.getElementsByName('iphone')[0].focus();
        this.regErr()
        return ''
      }
      _this.slideVS = true
      _this.getJigsawCode(function(res) {
        sessionStorage.setItem('cacheAdress', JSON.stringify(res.data));
        _this.countDown();
        _this.isInputCode = _this.isDisabled = true;
      });
    },
    ERR () {
      console.log(444)
    },
    cacheInput: function(v, e) {
      var obj = this.ruleForm2
      sessionStorage.setItem('cacheRegiater', JSON.stringify(obj))
    },
    onlyNumber: function(v) {
      var obj = this.ruleForm2
      var str = obj[v]
      obj[v] = str.replace(/\D/g, '')
      this.ruleForm2 = obj
    },
    getJigsawCode: function(cb) {
      // 获取验证码
      if (!this.ExhID) {
        this.$alert('缺失了展馆ID')
      }
      var SmsSign = sessionStorage.getItem('SmsSign') || '昆仑亿发'
      api.getVerifyToken({
        WapToken: sessionStorage.getItem('token'),
        ExhID: this.ExhID
      })
      .then(res2 => {
        // 获取拼图token；
        if (res2.data.status === 'OK') {
          var param = {
            ExhID: this.ExhID,
            sign: SmsSign,
            RegistType: 'pc',
            NotUseCache: 'yes',
            mobile: this.ruleForm2.iphone,
            openid: '',
            imgcode: '',
            token: res2.data.token,
            type: '',
            WapToken: sessionStorage.getItem('token')
          }
          api.getVerificationCode(param).then(res => {
            if (res.data.status === 'OK') {
              if (cb) {
                cb(res)
              }
            } else {
              this.$alert(res.data.ErrorMsg, '提示')
              this.$refs.verify.refresh();
            }
          })
        } else {
          this.$alert(res2.data.ErrorMsg, '提示')
          this.$refs.verify.refresh();
        }
      })
    },
    clearSpace: function(n) {
      // 清楚空格
      var obj = this.ruleForm2
      if (n === 'userName') {
        obj[n] = obj[n].trim()
      } else if (n === 'iphone' || n === 'code') {
        obj[n] = obj[n].replace(/\D/g, '')
      } else {
        obj[n] = obj[n].replace(/\s+/gim, '')
      }
      this.ruleForm2 = obj
      this.cacheInput()
      return false
    },
    loadInfoPageConfig: function(callback) {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'AddInfo',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          var switchInfos = res.data.switchInfos
          for (var i = 0; i < switchInfos.length; i++) {
            if (switchInfos[i].name === 'IfSubmit') {
              sessionStorage.setItem('IfSubmit', switchInfos[i].data)
            } else if (switchInfos[i].name === 'PrivacySwitch') {
            }
          }
          if (callback) {
            callback()
          }
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    submit: function(elemRef) {
      // 提交登陆/注册信息

      var obj = this.ruleForm2
      if (!regExp.notEmpty.test(obj.userName)) {
        this.$alert('Please enter your name')
        document.getElementsByName('userName')[0].focus()
        return ''
      } else if (obj.userName.length < 2) {
        this.$alert('Name length cannot be less than 2 digits')
        document.getElementsByName('userName')[0].focus()
        return ''
      } else if (
        !regExp.regCheckCnName.test(obj.userName) &&
        !regExp.regCheckEnName.test(obj.userName)
      ) {
        this.$alert('Name format is incorrect, please re-enter')
        document.getElementsByName('userName')[0].focus()
        return ''
      } else if (!regExp.notEmpty.test(obj.email)) {
        this.$alert('Please enter your email')
        document.getElementsByName('email')[0].focus()
        return ''
      } else if (!regExp.regCheckEmail.test(obj.email)) {
        this.$alert('The email format is incorrect, please re-enter')
        document.getElementsByName('email')[0].focus()
        return ''
      }
      this.showBtnLoading = true
      var param = {
        ExhID: this.ExhID,
        email: this.ruleForm2.email
      }
      api.CheckEmailToRegisted(param).then(res => {
        this.showBtnLoading = false
        sessionStorage.setItem('isLogin', true)
        if (res.data.status === 'OK' && res.data.PsjID) {
          this.loadInfoPageConfig(() => {
            sessionStorage.setItem('PsjID', res.data.PsjID)
            this.$store.commit('setUserID', res.data.PsjID)
            this.$router.push({
              path: 'confirmation',
              query: { ExhID: this.ExhID }
            })
          })
        } else if (res.data.status === 'OK' && !res.data.PsjID) {
          // 根据手机号获取往届数据 getPeronInfoInterface
          api
            .getPeronInfo({
              ExhID: this.ExhID,
              email: this.ruleForm2.email
            })
            .then(res => {
              if (res.data.status === 'OK') {
                this.$store.commit('setPreviousUser', true)
                // TODD: check user data structure
                this.$store.commit('setUserInfo', res.data)
              }
              this.$router.push({
                path: 'basicInfo',
                query: { ExhID: this.ExhID }
              })
            })
        } else if (res.data.ErrorMsg === '当前邮箱未在此届展会下注册') {
          // 没注册
          this.$router.push({
            path: 'basicInfo',
            query: { ExhID: this.ExhID }
          })
        } else {
          sessionStorage.setItem('isLogin', false)
          this.$alert(
            res.data.ErrorMsg ? res.data.ErrorMsg : res.data.ErrorEMsg,
            '提示'
          )
        }
      })
    },
    countDown: function() {
      // 倒计时
      var num = 59
      var stop = setInterval(() => {
        num--
        if (num < 0) {
          clearInterval(stop)
          this.$refs.verify.refresh();
        } else {
          this.countDownNum = num
        }
      }, 1000)
    }
  }
}
</script>

<style>
.loginBgReg{
  background: url('../../static/img/loginBg.jpg') no-repeat center center;
  background-size: cover;
}
.loginReg{
  margin: 0px auto;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  /* min-height: 620px; */
  display: flex;
}
.loginMainReg{
  /* width: 980px; */
  margin: 0px auto;
  display: inline-block;
  padding: 60px 0 60px 0;
}
.loginReg .leftReg {
  /* float: right;
  width: 40%;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%; */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.leftReg img {
  /* height: 100%; */
  height: 650px;
  border-right: 1px solid #eee;
}
.loginReg .rightReg{
  /* float: right;
  width: 60%; */
  width: 480px;
  height: inherit;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 30px 0;
  position: relative;
}
.rightReg .formBoxReg {
  padding: 0px 60px;
}
.leftReg h3 {
  font-weight: normal;
  padding-bottom: 55px;
  font-size: 20px;
}
.rightReg h3{
  text-align: left;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
}
.div-inlineReg b{
  font-weight: normal;
  font-size: 12px;
  padding: 0;
  line-height: 30px;
  width: 100%;
  text-align: left;
  display: inline-block;
}
.div-inlineReg{
  align-items: center;
}
.demo-ruleFormloginReg .el-input{
  width:100%;
  margin:0;
}
.verify-btn{
  display: none;
}
.smsCode{
  border:1px solid #DCDFE6;
  border-radius: 4px;
}
.smsCode .code-input{
  flex: 1;
}
.smsCode .code-input .el-input__inner{
  border:0;
}
.count-down,
.smsCode .el-button--primary,
.smsCode .el-button--primary:hover,
.smsCode .el-button--primary:focus,
.smsCode .el-button--primary:active{
  height:40px;
  margin-left: 15px;
  background: transparent !important;
  color: var(--themeColor) !important;
  border: 0;
  width: 120px;
  text-align: center;
  padding:0;
  height: 42px;
  line-height: 42px;
  flex: none;
}
.llqTips {
  padding: 0 20px;
  position: absolute;
  left: 40px;
  bottom: 10px;
}
/*滑块 sss*/
.switer-box {
  width: 300px;
  height: 30px;
  margin: 10px auto;
}
#loginReg .el-slider__button {
  width: 40px;
  height: 30px;
  border-radius: 0;
}
#loginReg .el-slider__bar {
  height: 30px;
}
.el-slider__runway {
  height: 30px;
}
#loginReg .el-slider__button-wrapper {
  top: 0;
}
/*滑块 eee*/
.switer-img {
  width: 300px;
  height: 150px;
  margin: 10px autp;
}
.canvas-box {
  width: 300px;
  height: 150px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.canvas-box .canvas {
  position: absolute;
  left: 0;
  top: 0;
}
.row-bg {
  background: #fff;
  min-height: calc(100vh);
  overflow: hidden;
}
.row-bg img {
  /* max-width: 300px; */
  margin: 0 auto;
}
.row-bg p {
  text-align: center;
  color: #424242;
  font-size: 14px;
}
.row-bg .rightReg {
  float: right;
  width: 60%;
  box-sizing: border-box;
  padding: 30px 0;
}
.demo-ruleFormloginReg{
  width: 100%;
  margin:60px auto;
  width:100%;
}
.holder {
  height: 230px;
}
.com-name {
  text-align: center;
  font-size: 20px;
  color: #424242;
  width: 80%;
  margin: 20px auto 40px;
}
.code-input {
  width: 50%;
  min-width: 150px;
}
.el-form-item__content {
  margin-left: 0 !important;
}
#loginReg .el-slider__runway {
  text-align: center;
  color: #c7c7c7;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
}
.el-slider__runway:after {
  content: '向右滑动完成拼图获取验证码...';
  color: red;
}
#loginReg .el-slider__button-wrapper::after {
  content: '→';
  position: absolute;
  left: 7px;
  top: 0;
  font-size: 28px;
  color: #17202e;
  line-height: 1;
}
.submit-btn, .submit-btn:hover{
  display: block !important;
  width:100% !important;
  margin:0 auto !important;
  margin-top:80px !important;
}
.flex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-start;
  justify-content: flex-start;
}
.count-down {
  height: 40px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue